import Vue from 'vue';
import Vuex, { Commit } from 'vuex';
import axios from 'axios';
Vue.use(Vuex);

import { nkd, couponPaymentDates } from '../libs/nkd';
import { DateTime } from 'luxon';

interface State {
	nkd: {
		[key: string]: {
			values: {
				[key: string]: number;
			};
		};
	};
	couponPaymentDates: {
		[key: string]: {
			values: {
				[key: string]: number;
			};
		};
	};
	issues: any;
}

const state: State = {
	nkd,
	couponPaymentDates,
	issues: {}
};

const getters = {
	nkd(state: State) {
		return state.nkd;
	},
	couponPaymentDates(state: State) {
		return state.couponPaymentDates;
	},
	issues(state: State) {
		return state.issues;
	},
	getBonds(state: State) {
		let bonds = { ...state.issues };
		let currentDate = DateTime.local();
		for (const key in bonds) {
			let item = bonds[key];
			bonds[key]['last-deal'] = (item['cena-poslednej-sdelki'] * 1000) / 100;
			bonds[key]['nkd'] = state.nkd[key].values[currentDate.toFormat('dd.MM.yyyy')] || 0;
			bonds[key]['dohodnost-k-pogasheniyu'] =
				(Math.pow(1 + item['stavka-kupona'] / 100 / item.vyplatKupona, item.vyplatKupona) * item['nominal']) / 100;
			bonds[key]['data-vyplaty-kupona'] = Object.keys(state.couponPaymentDates[key].values)
				.filter((item) => {
					let day = DateTime.fromFormat(item, 'dd.MM.yyyy').toSeconds();
					return currentDate.toSeconds() <= day;
				})
				.shift();
			// bonds[key]['velichina-kupona'] = state.couponPaymentDates[key][bonds[key]['data-vyplaty-kupona']];
		}
		return bonds;
	}
};

const mutations = {
	setIssues(state: State, issues: any) {
		state.issues = issues;
	}
};

const actions = {
	loadIssues({ commit }: { commit: Commit }) {
		axios
			.post(`/docs/moex/dannye-po-obligaciyam.json`)
			.then(({ data: response }) => {
				commit('setIssues', response);
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			})
			.finally(function () {
				// always executed
			});
	}
};

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	strict: process.env.NODE_ENV !== 'production'
});
